"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRunningAsJest = exports.useDropdown = exports.getSelectedKey = exports.isBetween = exports.removeUndefinedFromCollection = exports.isPrimitive = exports.isObject = exports.isArray = exports.getDataType = exports.axisFormatter = exports.axisFormatterFormat = exports.getDateFormatFromType = exports.parseData = exports.prepareDataSeriesOptions = exports.randomInt = exports.delay = exports.calculateScale = exports.getAxisTicks = exports.parseDomain = exports.formatAxisData = exports.usePrevious = exports.separateRectangles = exports.getAxisTypeFromData = exports.isValidAxisType = exports.extractKeys = exports.extractStateDatasets = exports.getDataIds = exports.extractDatasets = exports.valueFormat = exports.handleKeyboardCommand = void 0;
const d3_1 = require("d3");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const constants_1 = require("./constants");
const date_1 = require("./date");
const format_1 = require("./format");
const getSingleFormat = data => {
  const dataAsArray = Array.isArray(data) ? data : [data];
  const types = (0, lodash_1.default)(dataAsArray).map(function () {
    let {
      metric: {
        y_type: yType
      } = {}
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return yType ? String(yType).toLowerCase() : undefined;
  }).uniq().compact().value();
  if (types.length === 0) {
    return null;
  }
  if (types.length > 1) {
    return 'default';
  }
  return types[0];
};
const handleKeyboardCommand = (event, callback) => event && event.key && ['Enter', ' '].includes(event.key) ? callback() : undefined;
exports.handleKeyboardCommand = handleKeyboardCommand;
const valueFormat = _ref => {
  let {
    data = [],
    parent = {},
    params: {
      format,
      basic = false
    }
  } = _ref;
  const valueType = format || getSingleFormat(data) || (parent && parent.metric ? parent.metric.y_type : null) || 'default';
  if (basic) {
    return format_1.TOOLTIP_FORMATS[valueType.toLowerCase()] || format_1.TOOLTIP_FORMATS.default;
  }
  return format_1.VALUE_FORMATS[valueType.toLowerCase()] || format_1.VALUE_FORMATS.default;
};
exports.valueFormat = valueFormat;
const extractDatasets = data => lodash_1.default.map(data, metric => {
  if (metric.datasets && lodash_1.default.isArray(metric.datasets)) {
    const dataset = lodash_1.default.first(metric.datasets) || {};
    return {
      ...metric,
      ...dataset,
      id: (dataset.id || metric.id).toString(),
      sources: metric.sources
    };
  }
  return metric;
});
exports.extractDatasets = extractDatasets;
const getDataIds = data => {
  if (data !== null && data !== void 0 && data.datasets) {
    return data.datasets.map(_ref2 => {
      let {
        id
      } = _ref2;
      return id;
    }).join();
  }
  return data === null || data === void 0 ? void 0 : data.map(datum => {
    if (datum.datasets && Array.isArray(datum.datasets)) {
      return (0, exports.getDataIds)(datum.datasets);
    }
    return datum === null || datum === void 0 ? void 0 : datum.id;
  }).join();
};
exports.getDataIds = getDataIds;
const extractStateDatasets = data => {
  if (data.datasets && lodash_1.default.isArray(data.datasets)) {
    const datasets = data.datasets || {};
    return {
      datasets,
      sources: data.sources
    };
  }
  return data;
};
exports.extractStateDatasets = extractStateDatasets;
const extractKeys = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  const allKeys = (0, lodash_1.default)(data).map(function () {
    let {
      x_type: xType,
      data: values = []
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, lodash_1.default)(values).map(_ref3 => {
      let {
        key
      } = _ref3;
      return {
        key,
        x_type: xType
      };
    }).filter(_ref4 => {
      let {
        key
      } = _ref4;
      return key;
    }).value();
  }).value();
  return (0, lodash_1.default)(allKeys).flatten().map(_ref5 => {
    let {
      key,
      x_type: xType
    } = _ref5;
    return {
      key,
      formatted: typeof formatter === 'function' ? formatter(key, xType) : key
    };
  }).uniqBy(_ref6 => {
    let {
      key
    } = _ref6;
    return key;
  }).value();
};
exports.extractKeys = extractKeys;
const isValidAxisType = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return constants_1.AXIS_TYPES.includes(String(type).toLowerCase());
};
exports.isValidAxisType = isValidAxisType;
const getAxisTypeFromData = (data, axisType) => {
  if (['x', 'y'].includes(axisType) === false) {
    return false;
  }
  const aTypes = Object.entries((0, lodash_1.default)(data).groupBy(`${axisType}_type`).value()).map(_ref7 => {
    let [type, arr] = _ref7;
    return {
      type: type.toLowerCase(),
      count: arr.length
    };
  }).sort((a, b) => a.count > b.count ? -1 : 1);
  if (!aTypes.length || !(0, exports.isValidAxisType)(aTypes[0].type)) {
    return false;
  }
  return aTypes[0].type;
};
exports.getAxisTypeFromData = getAxisTypeFromData;
/**
 * Takes in rectangle points and separates them based on their height or width
 *
 * @param {Array} rectangles array of points { point, size }
 * @param {Number} maxPoint max allowed coordinate
 *
 * @returns updated rectangle array with new point point
 */
const separateRectangles = (rectangles, maxPoint) => {
  const data = rectangles.map((rect, index) => ({
    ...rect,
    index,
    wasAdjusted: false
  }));
  let spilloverAmount = 0; // how much have we passed max coord
  let availableSpace = 0; // how much space is in the range
  data
  // sort from top to bottom
  .sort((_ref8, _ref9) => {
    let {
      point: p1
    } = _ref8;
    let {
      point: p2
    } = _ref9;
    return p1 < p2 ? -1 : 1;
  }).forEach((_ref10, i, rectArr) => {
    let {
      point,
      size
    } = _ref10;
    const currRect = rectArr[i];
    const prevRect = rectArr[i - 1];
    // first element is baseline, dont do anything to it yet
    if (i === 0) {
      availableSpace = point;
      return;
    }
    // overlap amount
    const sizeDif = point - prevRect.point;
    // if curr and prev are not overlapping, add to available space
    if (sizeDif >= size) {
      availableSpace += sizeDif - size;
      return;
    }
    // how much to shift current item down
    let currentAdjustment = size - sizeDif;
    // we haven't moved the previous one, so offset 1/2 to each
    if (!prevRect.wasAdjusted) {
      currentAdjustment /= 2;
      prevRect.wasAdjusted = true;
      prevRect.point -= currentAdjustment;
      if (prevRect.point < 0) {
        currentAdjustment += 0 - prevRect.point;
        prevRect.point = 0;
      }
    }
    currRect.wasAdjusted = true;
    currRect.point += currentAdjustment;
    // we've gone past the end
    if (currRect.point >= maxPoint) {
      spilloverAmount += currRect.point - maxPoint;
      currRect.point = maxPoint;
    }
  });
  // major issue... too many boxes not enough space!
  if (spilloverAmount > availableSpace) {
    throw new Error('Cannot distribute all data properly, not enough available range.');
  }
  // we have spillover off the end
  if (spilloverAmount) {
    // flip it, start from the end
    data.reverse().some((_ref11, i, rectArr) => {
      let {
        point,
        size
      } = _ref11;
      const currRect = rectArr[i];
      const prevRect = rectArr[i - 1];
      const nextLine = rectArr[i + 1];
      // we're past the end point, bring it in the box
      if (point > maxPoint) {
        currRect.point = maxPoint;
      }
      // dont move first element, it's already at the end
      if (i === 0) {
        return false;
      }
      currRect.point = prevRect.point - size;
      // no more overlapping, so no need to proceed
      return nextLine && nextLine.point < currRect.point - size;
    });
  }
  // resort array to original order
  data.sort((_ref12, _ref13) => {
    let {
      index: i1
    } = _ref12;
    let {
      index: i2
    } = _ref13;
    return i1 < i2 ? -1 : 1;
  });
  return data;
};
exports.separateRectangles = separateRectangles;
function usePrevious(value) {
  const ref = (0, react_1.useRef)();
  (0, react_1.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
exports.usePrevious = usePrevious;
function formatAxisData(axisType, type, data) {
  const allDatesKey = axisType === 'x' ? 'x_type' : 'y_type';
  return (0, date_1.isDateType)(type) ? (0, exports.extractKeys)([{
    [allDatesKey]: type,
    data: data.map(i => ({
      key: i,
      value: null
    }))
  }], (key, type) => (0, date_1.dateParser)(key, type)).map(i => i.formatted) : data;
}
exports.formatAxisData = formatAxisData;
function parseDomain(domainToParse, currentDomain) {
  if (!domainToParse || !Array.isArray(domainToParse)) {
    return currentDomain;
  }
  if (domainToParse.some(i => Number.isNaN(parseFloat(i)) && !lodash_1.default.isDate(i) && i !== undefined)) {
    return currentDomain;
  }
  return [domainToParse[0] !== undefined ? domainToParse[0] : currentDomain[0], domainToParse[1] !== undefined ? domainToParse[1] : currentDomain[1]];
}
exports.parseDomain = parseDomain;
function getAxisTicks(_ref14) {
  let {
    axisType,
    scale,
    count = 5,
    customTicks = undefined
  } = _ref14;
  const domain = scale.domain();
  const showZeroLine = axisType === 'y' && domain[0] < 0 && domain[1] > 0;
  const ticks = Array.isArray(customTicks) && customTicks.length > 0 ? customTicks : scale.ticks(count);
  // if we want a zero line, and it doesn't already exist, and we have a positive tick;
  if (showZeroLine && !ticks.includes(0)) {
    const zeroIndex = ticks.findIndex(v => v > 0);
    ticks.splice(zeroIndex, 0, 0);
  }
  return ticks;
}
exports.getAxisTicks = getAxisTicks;
function calculateScale(type, domain) {
  if ((0, date_1.isDateType)(type)) {
    return (0, d3_1.scaleUtc)().domain(domain);
  }
  return (0, d3_1.scaleLinear)().domain(domain);
}
exports.calculateScale = calculateScale;
function delay() {
  let time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  return new Promise(resolve => {
    setTimeout(resolve, time);
  });
}
exports.delay = delay;
function randomInt() {
  let min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000;
  const num = Math.random() * (max - min) + min;
  return Math.round(num);
}
exports.randomInt = randomInt;
function prepareDataSeriesOptions(datasets) {
  let rawDataSeriesOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  const rdso = Array.isArray(rawDataSeriesOptions) ? rawDataSeriesOptions : [];
  return datasets.map(data => {
    const metric = rdso.find(i => i[key] === data[key]);
    return metric || {
      id: data.id
    };
  });
}
exports.prepareDataSeriesOptions = prepareDataSeriesOptions;
function parseData(datasets, dataSeriesOptions) {
  let keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const extractedKeys = lodash_1.default.concat(['id', 'data'], lodash_1.default.isArray(keys) ? keys : []);
  return datasets.map(d => {
    const data = lodash_1.default.pick(d, extractedKeys);
    const metric = dataSeriesOptions.find(i => i.id === data.id);
    return {
      ...data,
      metric,
      data: data.data.filter(function () {
        let {
          value
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Number.isFinite(value);
      })
    };
  }).filter(d => d);
}
exports.parseData = parseData;
const getDateFormatFromType = type => {
  switch (String(type).toLowerCase()) {
    case 'years':
    case 'yearly':
      return '%Y';
    case 'quarters':
    case 'quarterly':
      return 'Q%q';
    case 'months':
    case 'monthly':
      return '%b';
    case 'weeks':
    case 'weekly':
      return '%_d';
    case 'days':
    case 'daily':
      return '%_d';
    default:
      return '%Y';
  }
};
exports.getDateFormatFromType = getDateFormatFromType;
const axisFormatterFormat = (value, index, ticks, type) => {
  const [min, max] = [lodash_1.default.min(ticks), lodash_1.default.max(ticks)];
  const yearDiff = d3_1.utcYear.count(min, max);
  const monthDiff = d3_1.utcMonth.count(min, max);
  const date = new Date(value);
  if (!date) {
    return null;
  }
  const prevDate = index > 0 ? new Date(ticks[index - 1]) : false;
  const dateFormat = (0, exports.getDateFormatFromType)(type);
  if (yearDiff >= 1 && prevDate && (prevDate.getUTCMonth() !== 0 && date.getUTCMonth() === 0 || prevDate.getUTCFullYear() !== date.getUTCFullYear())) {
    return '%Y';
  }
  if (['weeks', 'weekly', 'days', 'daily'].includes(String(type).toLowerCase()) && monthDiff >= 1 && (!prevDate || prevDate.getUTCMonth() !== date.getUTCMonth())) {
    return '%b';
  }
  return dateFormat;
};
exports.axisFormatterFormat = axisFormatterFormat;
const axisFormatter = _ref15 => {
  let {
    dataType,
    isMobile = false
  } = _ref15;
  if (!dataType || !(0, date_1.isDateType)(dataType)) {
    return (0, exports.valueFormat)({
      params: {
        format: dataType
      }
    });
  }
  const formatterFn = (value, _ref16) => {
    let {
      ticks
    } = _ref16;
    const date = new Date(value);
    if (!date) {
      const baseFormatter = (0, exports.valueFormat)({
        params: {
          format: dataType
        }
      });
      return baseFormatter(value, {
        ticks
      });
    }
    const index = ticks.findIndex(i => i.getTime() === value);
    let format = (0, exports.axisFormatterFormat)(value, index, ticks, dataType);
    // we're first one
    if (index === 0) {
      // let's see the formate of all the others
      const tickFormats = ticks.map((t, i) => (0, exports.axisFormatterFormat)(t, i, ticks, dataType)).slice(1);
      // all of them are the same
      if (tickFormats.every(tf => tf === tickFormats[0])) {
        // format this one the same
        [format] = tickFormats;
      }
    }
    let formattedValue = (0, d3_1.utcFormat)(format)(date);
    if (isMobile === true && format === '%b') {
      formattedValue = formattedValue.substr(0, 1);
    }
    return formattedValue;
  };
  return formatterFn;
};
exports.axisFormatter = axisFormatter;
const DT_ARRAY = 'dt_array';
const DR_OBJECT = 'dt_object';
const DR_PRIMITIVE = 'dt_primitive';
const getDataType = i => {
  if ([DT_ARRAY, DR_OBJECT, DR_PRIMITIVE].includes(i)) {
    return i;
  }
  if (lodash_1.default.isArray(i)) {
    return DT_ARRAY;
  }
  if (lodash_1.default.isPlainObject(i)) {
    return DR_OBJECT;
  }
  return DR_PRIMITIVE;
};
exports.getDataType = getDataType;
const isArray = t => (0, exports.getDataType)(t) === DT_ARRAY;
exports.isArray = isArray;
const isObject = t => (0, exports.getDataType)(t) === DR_OBJECT;
exports.isObject = isObject;
const isPrimitive = t => (0, exports.getDataType)(t) === DR_PRIMITIVE;
exports.isPrimitive = isPrimitive;
const removeUndefinedFromCollection = d => {
  const collectionType = (0, exports.getDataType)(d);
  if ((0, exports.isPrimitive)(collectionType)) {
    return d;
  }
  const newCollection = (0, exports.isObject)(collectionType) ? {} : [];
  return lodash_1.default.reduce(d, (acc, v, k) => {
    const itemType = (0, exports.getDataType)(v);
    // undefined or no keys (arr | obj)
    if (v === undefined || (0, exports.isArray)(itemType) && v.length === 0 || (0, exports.isObject)(itemType) && lodash_1.default.keys(v).length === 0) {
      return acc;
    }
    if ((0, exports.isArray)(itemType)) {
      return {
        ...acc,
        [k]: v.map(i => (0, exports.removeUndefinedFromCollection)(i))
      };
    }
    if ((0, exports.isObject)(itemType)) {
      return {
        ...acc,
        [k]: (0, exports.removeUndefinedFromCollection)(v)
      };
    }
    if ((0, exports.isArray)(collectionType)) {
      return [...acc, v];
    }
    return {
      ...acc,
      [k]: v
    };
  }, newCollection);
};
exports.removeUndefinedFromCollection = removeUndefinedFromCollection;
const isBetween = function (val, low, high) {
  let isInclusive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (isInclusive) {
    return val >= low && val <= high;
  }
  return val > low && val < high;
};
exports.isBetween = isBetween;
const getSelectedKey = (keys, selectedKey, defaultToFirst) => {
  if (keys && keys.length) {
    if (keys.find(_ref17 => {
      let {
        key
      } = _ref17;
      return key === selectedKey;
    })) {
      return selectedKey;
    }
    if (defaultToFirst) {
      return keys[0].key;
    }
    return keys.slice(-1)[0].key;
  }
  return null;
};
exports.getSelectedKey = getSelectedKey;
const useDropdown = _ref18 => {
  let {
    color = undefined,
    defaultToFirst = false,
    enabled,
    keys: _keys,
    label,
    parser,
    sortBy,
    targetKey
  } = _ref18;
  const keys = _keys !== null && _keys !== void 0 && _keys.length ? [..._keys] : [];
  if (sortBy !== false) {
    keys.sort((a, b) => {
      const [dir1, dir2] = sortBy === 'descending' ? [1, -1] : [-1, 1];
      if (a.formatted && b.formatted) {
        return a.formatted < b.formatted ? dir1 : dir2;
      }
      return a < b ? -1 : 1;
    });
  }
  const selectedKey = (0, exports.getSelectedKey)(keys, targetKey, defaultToFirst);
  const [key, setKey] = (0, react_1.useState)(selectedKey);
  (0, react_1.useEffect)(() => {
    setKey(selectedKey);
  }, [selectedKey]);
  let dropdownOpts = [];
  if (keys && keys.length) {
    dropdownOpts = enabled ? keys.map(function () {
      let {
        key
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return key;
    }) : [selectedKey];
  }
  const dropdown = dropdownOpts.length ? {
    color,
    options: dropdownOpts,
    parser,
    label,
    value: (0, exports.getSelectedKey)(keys, key),
    onChange: _ref19 => {
      let {
        target: {
          value
        }
      } = _ref19;
      const parsedKey = keys.find(_ref20 => {
        let {
          parsed
        } = _ref20;
        return parsed === value;
      });
      if (parsedKey && parsedKey.key) {
        setKey(parsedKey.key);
      }
    }
  } : null;
  return {
    key,
    setKey,
    dropdown
  };
};
exports.useDropdown = useDropdown;
/**
 * This utility function was designed to indirectly solve a test-time issue.
 * This is a perfect example of solving a wall scratch by putting up new sheetrock.
 * @returns {boolean} Whether this environment is Jest :shrug:
 */
const isRunningAsJest = () => {
  try {
    return process && process.env && process.env.JEST_WORKER_ID !== undefined;
  } catch (e) {/* do nothing */}
  return false;
};
exports.isRunningAsJest = isRunningAsJest;